import React, { useState } from "react";

const SalesforceFileModal = ({
  show,
  onClose,
  sfdcFiles,
  onSelect,
  isFetching,
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  if (!show) return null;

  const toggleSelection = (file) => {
    setSelectedFiles((prev) =>
      prev.some((f) => f.id === file.id)
        ? prev.filter((f) => f.id !== file.id)
        : [...prev, file]
    );
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-black/40 backdrop-blur-[2px] flex justify-center items-center">
      <div className="bg-white rounded-2xl shadow-2xl w-[480px] max-h-[80vh] overflow-hidden flex flex-col animate-fadeIn">
        {/* Header */}
        <div className="flex justify-between items-center px-5 py-4 border-b border-gray-200 bg-gradient-to-r from-[#8B55DD]/5 to-white">
          <h2 className="text-lg font-semibold text-gray-800 tracking-tight">
            Select Salesforce Files
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700 transition-transform transform hover:scale-110"
          >
            ✕
          </button>
        </div>

        {/* File List */}
        <div className="flex-1 overflow-y-auto px-4 py-3 scrollbar-thin scrollbar-thumb-[#C9B8EE] scrollbar-track-transparent">
          {isFetching ? (
            <p className="text-gray-500 text-center py-6">Loading files...</p>
          ) : sfdcFiles.length > 0 ? (
            <ul className="divide-y divide-gray-100 space-y-2">
              {sfdcFiles.map((file) => {
                const isSelected = selectedFiles.some((f) => f.id === file.id);
                return (
                  <li
                    key={file.id}
                    onClick={() => toggleSelection(file)}
                    className={`flex items-center justify-between px-3 py-2 rounded-lg cursor-pointer transition-all duration-200 ${
                      isSelected
                        ? "bg-[#8B55DD]/10 border border-[#8B55DD]/30"
                        : "hover:bg-gray-50"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-gray-50 rounded-md">
                        <img
                          src="/file-icon.svg"
                          className="w-5 h-5 opacity-80"
                          alt="SFDC File"
                        />
                      </div>
                      <span
                        className={`text-sm font-medium truncate w-[280px] ${
                          isSelected ? "text-[#7B3CCD]" : "text-gray-700"
                        }`}
                      >
                        {file.title}
                      </span>
                    </div>
                    {/* {isSelected && (
                      <img
                        src="/tick-icon.svg"
                        alt="Selected"
                        className="w-4 h-4"
                      />
                    )} */}
                  </li>
                );
              })}
            </ul>
          ) : (
            <p className="text-gray-500 text-center py-6">
              No files found in Salesforce.
            </p>
          )}
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 border-t border-gray-200 px-5 py-3 bg-gray-50">
          <button
            className="px-4 py-2 rounded-md text-sm font-medium text-gray-700 bg-white border border-gray-200 hover:bg-gray-100 transition-all"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            disabled={selectedFiles.length === 0}
            onClick={() => onSelect(selectedFiles)}
            className={`px-4 py-2 rounded-md text-sm font-medium text-white bg-[#8B55DD] hover:bg-[#7B3CCD] transition-all shadow-sm ${
              selectedFiles.length === 0
                ? "opacity-60 cursor-not-allowed"
                : "hover:shadow-md"
            }`}
          >
            Select{" "}
            {selectedFiles.length > 0 ? `(${selectedFiles.length})` : ""}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SalesforceFileModal;
